export const formatNumberInt = (numToFormat: number, lang: string): string => {
  return new Intl.NumberFormat(lang).format(numToFormat);
};
